import { useEffect, useRef, useState } from "react";

const FrequencyTermList = ({ termList, frequency }) => {
  const textBoxRef = useRef();
  const [charCount, setCharCount] = useState(null);

  useEffect(() => {
    if (textBoxRef.current) {
      console.log(textBoxRef.current.textContent);
      const count = textBoxRef.current.textContent.trim().length;
      setCharCount(count);
    }
  }, [textBoxRef, termList]);

  if (!termList) return;

  const jsxTermList = termList.map(({ term, banned }) => {
    return (
      <span
        key={`${frequency}-${term}`}
        className={banned ? "banned-word" : ""}
      >
        {term}{" "}
      </span>
    );
  });

  const updateCount = () => {
    if (textBoxRef.current) {
      const count = textBoxRef.current.textContent.trim().length;
      setCharCount(count);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
      }}
    >
      <h2
        style={{
          borderBottom: "2px solid var(--blue-primary)",
          width: "fit-content",
        }}
      >
        Minimum {frequency} frequency
      </h2>
      <p>Total characters: {charCount}</p>
      <p
        ref={textBoxRef}
        contentEditable="true"
        onInput={updateCount}
        style={{
          padding: "1rem",
          background: "white",
          color: "black",
          borderRadius: ".3rem",
          boxShadow: "inset 0 0 5px gray",
        }}
      >
        {jsxTermList}
      </p>
    </div>
  );
};

export default FrequencyTermList;
